module.exports = __webpack_public_path__ + "img/paas_wrapbg2.c164d4a2.png";